module.exports = __webpack_public_path__ + "static/media/baatvrakwback.7f5ec23f.svg";